/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statswindow30d1Inputs */

const en_statswindow30d1 = /** @type {(inputs: Statswindow30d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 30 days`)
};

const de_statswindow30d1 = /** @type {(inputs: Statswindow30d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 30 Tage`)
};

/**
* | output |
* | --- |
* | "Last 30 days" |
*
* @param {Statswindow30d1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statswindow30d1 = /** @type {((inputs?: Statswindow30d1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statswindow30d1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statswindow30d1(inputs)
	return de_statswindow30d1(inputs)
});
export { statswindow30d1 as "statsWindow30d" }